<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      PARAMÈTRES
    </div>
  </dxi-item>
  <dxi-item location="after">
    <div class="d-flex flex-row align-items-center">
      <yo-button
        label="Enregistrer"
        tooltip="Enregistrer"
        type="submit"
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="save()">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>

<div class="row mg-t-5 mg-l-5">
  <div class="col-md-12">
    <form>
      <div class="form-group row">
        <label [class.requiredControl]="true"
               class="genlabel col-sm-3 col-form-label"
               [style.max-width.px]="150"
               >Logo</label>
        <div class="col-sm-6 max-width-150">
          <input type="file"
                 accept="image/jpeg, image/png"
                 name="logoFile"
                 #logoInput
                 (change)="onChangeImage($event,'logo')">
          <div class="d-flex flex-row align-items-center">
            <img [src]="getImageSrc('logo', ParametreImageEnum.LOGO)" height="32">
            <yo-button
              class="mg-l-10"
              tooltip="Supprimer le logo et rétablir celui par défaut"
              iconClass="fas fa-trash"
              size="small"
              [theme]="ButtonThemeEnum.DELETE"
              (onClick)="removeImage(ParametreImageEnum.LOGO, 'logo', logoInput)">
            </yo-button>
          </div>
          @if (hasPreview('logo')) {
            <small class="preview-legend">
              Aperçu du fichier choisi — cliquez sur « Enregistrer » pour l'appliquer.
            </small>
          }
        </div>
      </div>
      <div class="form-group row">
        <label [class.requiredControl]="true"
               class="genlabel col-sm-3 col-form-label"
               [style.max-width.px]="150"
               >Fond d'écran</label>
        <div class="col-sm-6 max-width-150">
          <input type="file"
                 name="bgFile"
                 accept="image/jpeg, image/png"
                 #backgroundInput
                 (change)="onChangeImage($event,'background')">

          <div class="d-flex flex-row align-items-start">
            <img style="border:1px dashed gray;" [src]="getImageSrc('background', ParametreImageEnum.BACKGROUND)"
                 height="200">
            <yo-button
              class="mg-l-10"
              tooltip="Supprimer le fond d'écran et rétablir celui par défaut"
              iconClass="fas fa-trash"
              size="small"
              [theme]="ButtonThemeEnum.DELETE"
              (onClick)="removeImage(ParametreImageEnum.BACKGROUND, 'background', backgroundInput)">
            </yo-button>
          </div>
          @if (hasPreview('background')) {
            <small class="preview-legend">
              Aperçu du fichier choisi — cliquez sur « Enregistrer » pour l'appliquer.
            </small>
          }

        </div>
      </div>
    </form>
    <div class="form-group row">
      <label [class.requiredControl]="true"
             class="genlabel col-sm-3 col-form-label"
             [style.max-width.px]="150"
      >Taux de perte</label>
      <div class="col-sm-6 max-width-150">
        <dx-check-box [(ngModel)]="useTauxDePerte">
        </dx-check-box>
      </div>
    </div>
  </div>
</div>
